import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Users from '../views/Users.vue'
import Profile from '../views/Profile.vue'
import Calls from '../views/Ringbacalls.vue'
import BillableReport from '../views/BillableReport.vue'
import Calls_quota from '../views/Calls_quota.vue'
import Refund_Requests from '../views/Refund_Requests'
import Per_week from '../views/Per_week'
import Settings from '../views/Settings.vue'
import AgentsTeams from '../views/AgentsTeams.vue'
import AgentPerformance from '../views/AgentPerformance.vue'

const routes = [
  // Role-gated pages: user can still type URL, but will be redirected to their "home" page.
  { path: '/', component: Home, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/users', component: Users, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/login', component: Login },
  { path: '/profile', component: Profile },
  { path: '/calls', component: Calls, meta: { requiresAuth: true, roles: ['admin', 'customer', 'manager'] } },
  { path: '/billable_report', component: BillableReport, meta: { requiresAuth: true, roles: ['admin', 'customer'] } },
  { path: '/calls_quota', component: Calls_quota, meta: { requiresAuth: true, roles: ['cross_sales_configurator'] } },
  { path: '/refund_requests', component: Refund_Requests, meta: { requiresAuth: true, roles: ['admin', 'QA'] } },
  { path: '/per_week', component: Per_week, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/settings', component: Settings, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/agents', component: AgentsTeams, meta: { requiresAuth: true, roles: ['admin', 'manager'] } },
  { path: '/agent_performance', component: AgentPerformance, meta: { requiresAuth: true, roles: ['admin', 'manager'] } }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const username = localStorage.getItem('username')

  const getHomePath = (roles) => {
    const r = new Set(Array.isArray(roles) ? roles : [])
    if (r.has('admin')) return '/'
    if (r.has('manager')) return '/calls'
    if (r.has('customer')) return '/billable_report'
    if (r.has('cross_sales_configurator')) return '/calls_quota'
    if (r.has('QA')) return '/refund_requests'
    return '/'
  }

  // Auth guard
  if (to.meta.requiresAuth && !token) {
    next('/login')
    return
  }

  // Role guard (for direct URL access)
  if (to.meta.roles && Array.isArray(to.meta.roles) && to.meta.roles.length > 0) {
    // If we don't even have auth context, send to login.
    if (!token || !username) {
      next('/login')
      return
    }

    const params = new URLSearchParams({ user: username })
    fetch(`/api/role?${params.toString()}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(async (res) => {
        if (!res.ok) throw new Error('Failed to fetch roles')
        const data = await res.json()
        const userRoles = Array.isArray(data?.roles) ? data.roles : []
        const allowed = to.meta.roles.some((role) => userRoles.includes(role))
        if (allowed) {
          next()
        } else {
          next(getHomePath(userRoles))
        }
      })
      .catch(() => next('/login'))

    return
  }

  next()
})

function postNavigationLog(to, from) {
  const token = localStorage.getItem('token')
  const username = localStorage.getItem('username')
  if (!token || !username) return
  if (to.path === '/login') return

  const payload = {
    to: to.fullPath,
    from: from.fullPath || '',
  }

  fetch('/api/logs', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      username,
      action_type: `page_visit payload=${JSON.stringify(payload)}`
    })
  }).catch(() => {})
}

router.afterEach((to, from) => {
  postNavigationLog(to, from)
})

export default router
